import React from 'react';
import './Partners.css';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';

const Partners = () => {
  const { language } = useLanguage();
  const t = translations[language];
  const logos = [
    { src: '/logos/logo-kmg.png', alt: 'KMG', fallback: 'KMG' },
    { src: '/logos/logo-alt-university.png', alt: 'ALT University', fallback: 'ALT University' },
    { src: '/logos/logo-kegoc.png', alt: 'KEGOC', fallback: 'KEGOC' },
    { src: '/logos/logo-aitu.png', alt: 'AITU', fallback: 'AITU' },
    { src: '/logos/logo-mnu.png', alt: 'MNU', fallback: 'MNU' },
  ];

  // Дублируем логотипы для бесшовной анимации
  const duplicatedLogos = [...logos, ...logos];

  return (
    <section className="partners" id="partners">
      <div className="partners-title">
        <div className="partners-tag">
          <span className="partners-tag-text">{t.partnersTag}</span>
        </div>
        <h2 className="partners-heading">{t.partnersTitle}</h2>
      </div>
      
      <div className="partners-carousel-wrapper">
        <div className="partners-carousel">
          {duplicatedLogos.map((logo, index) => (
            <div key={index} className="partners-logo">
              <img 
                src={logo.src} 
                alt={logo.alt}
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.parentElement.innerHTML = `<span style="font-size: 14px; color: #2C2B2F;">${logo.fallback}</span>`;
                }}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Partners;
